import QRCode from "react-qr-code";

interface ITotpQRCodeProps {
  value: string;
}

export const TotpQRCode = ({ value }: ITotpQRCodeProps) => (
  <div style={{ display: 'flex', justifyContent: 'center', margin: '3rem 0' }}>
    { value.length === 0 && (<div style={{width: 256, height: 256, backgroundColor: '#f0f0f0', borderRadius: '1rem'}} />) }
    { value.length > 0 && <QRCode value={value} /> }
  </div>
);
